import "bootstrap/dist/css/bootstrap.min.css";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";
import { BsPieChartFill } from "react-icons/bs";

// Register chart elements
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const ScheduledUnscheduledChart = ({ scheduledUnscheduledChart = [] }) => {

  const chartData =
    Array.isArray(scheduledUnscheduledChart) && scheduledUnscheduledChart.length > 0 ? scheduledUnscheduledChart : [
      { services_type: "Scheduled", count: 0 },
      { services_type: "Un-scheduled", count: 0 },
      { services_type: "N/A", count: 0 },
    ];

  const labels = chartData.map((item) => item.services_type);
  const values = chartData.map((item) => Number(item.count));

  const colorMap = {
    scheduled: "#2D7FF9",
    unscheduled: "#FFA500",
  };
  const backgroundColors = labels.map((label) => colorMap[label] || "#999");

  const pieData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: "#fff",
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        font: {
          weight: "bold",
          size: 14,
        },
      },
    },
  };

  return (
    <div className="card_container">
      <h5 className="mb-5 scheduled_unscheduled_heading">
        <BsPieChartFill color="#3343ea85" />
        Scheduled vs. Unscheduled Maintenance
      </h5>
      <div style={{ height: "260px" }}>
        <Pie data={pieData} options={options} plugins={[ChartDataLabels]} />
      </div>
      <div className="mt-4 d-flex justify-content-around flex-wrap">
        {labels.map((label, idx) => (
          <div
            key={idx}
            className="fw-bold"
            style={{ color: backgroundColors[idx] }}
          >
            ● {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduledUnscheduledChart;
